export default "__VITE_ASSET__Cn_P1o4h__"